import { useTranslate } from "ra-core";

import type { ColoredLabeledValue, Task, TaskStatus } from "../types";

export const TASK_STATUSES: { value: TaskStatus; color: string }[] = [
  { value: "todo", color: "#60a5fa" },
  { value: "done", color: "#22c55e" },
  { value: "abandoned", color: "#9ca3af" },
];

/** Task statuses with their translated labels. */
export const useTaskStatusChoices = (): ColoredLabeledValue[] => {
  const translate = useTranslate();
  return TASK_STATUSES.map((status) => ({
    ...status,
    label: translate(`resources.tasks.statuses.${status.value}`),
  }));
};

/** Fields to save when a task moves to `status` (done_date marks a closed task). */
export const taskStatusUpdate = (status: TaskStatus) => ({
  status,
  done_date: status === "todo" ? null : new Date().toISOString(),
});

/** Keeps done_date in step with a status chosen in a form (the database trigger does the same). */
export const applyTaskStatusChange = <T extends { status?: TaskStatus }>(
  data: T,
  previousData?: { status?: TaskStatus },
): T =>
  data.status && data.status !== previousData?.status
    ? { ...data, ...taskStatusUpdate(data.status) }
    : data;

/** An open task whose due date has passed. */
export const isTaskOverdue = (task: Task, now = new Date()) =>
  (task.status ?? "todo") === "todo" && new Date(task.due_date) < now;
